import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ContentContext = createContext(null);

// Render text where **word** becomes orange-highlighted spans.
export const renderRich = (text, highlightClass = "text-red-600") => {
    if (!text) return null;
    const parts = String(text).split(/\*\*(.+?)\*\*/g);
    return parts.map((p, i) =>
        i % 2 === 1 ? (
            <span key={i} className={highlightClass}>{p}</span>
        ) : (
            <span key={i}>{p}</span>
        )
    );
};

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);

    const fetchContent = async () => {
        try {
            const { data } = await api.get("/content");
            setContent(data);
        } catch {
            setContent({});
        }
    };

    useEffect(() => {
        fetchContent();
    }, []);

    return (
        <ContentContext.Provider value={{ content, refresh: fetchContent, setContent }}>
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => {
    const ctx = useContext(ContentContext);
    return ctx?.content || {};
};

export const useContentCtx = () => useContext(ContentContext);
